import React from "react";

/**
 * Shadow Container Component
 * Reusable container with shadow background and rounded corners
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to render inside the container
 * @param {string} [props.className] - Additional CSS classes to apply
 * @param {string} [props.maxWidth] - Maximum width class (default: 'max-w-6xl')
 * @param {string} [props.padding] - Padding class (default: 'p-8')
 * @param {string} [props.shadow] - Shadow class (default: 'shadow-lg')
 * @param {string} [props.rounded] - Border radius class (default: 'rounded-xl')
 */
const ShadowContainer = ({
  children,
  className = "",
  maxWidth = "max-w-6xl",
  padding = "p-8",
  shadow = "shadow-lg",
  rounded = "rounded-xl",
}) => {
  return (
    <div
      className={`bg-white ${rounded} ${shadow} ${padding} ${maxWidth} mx-auto ${className}`}
    >
      {children}
    </div>
  );
};

export default ShadowContainer;
